import { View, Pressable, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '@/theme';
import { ThemedText } from '@/components/ui/Text';

type NotificationBellProps = {
  count: number;
  onPress: () => void;
  accessibilityLabel?: string;
};

export function NotificationBell({ count, onPress, accessibilityLabel }: NotificationBellProps) {
  const theme = useTheme();

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? 'Open notifications'}
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.7 : 1,
          minWidth: 44,
          minHeight: 44,
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(1),
        },
      ]}
    >
      <View style={{ position: 'relative' }}>
        <Ionicons
          name="notifications-outline"
          size={24}
          color={theme.colors.text}
        />
        {count > 0 && (
          <View
            style={[
              styles.badge,
              {
                backgroundColor: theme.colors.error || '#FF3B30',
                borderColor: theme.colors.surface,
              },
            ]}
          >
            <ThemedText
              variant="caption"
              style={[
                styles.badgeText,
                {
                  color: theme.colors.surface,
                },
              ]}
            >
              {count > 99 ? '99+' : count.toString()}
            </ThemedText>
          </View>
        )}
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    top: -6,
    right: -6,
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 2,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    fontSize: 10,
    fontWeight: '700',
    lineHeight: 12,
  },
});
